import { useApolloClient } from '@apollo/client'

// The list is the only thing on the page showing subscriptions, and the
// cancel mutation does not return the updated record.
export const useRefetchSubscriptions = () => {
  const client = useApolloClient()
  return () => client.refetchQueries({ include: ['UserSubscriptionList'] })
}
